module.exports = __webpack_public_path__ + "static/visual_5_do-6fbef566f905e2bfd267d67cc268b246.png";